import React from 'react';
import {Button} from "primereact/button";
import config from "../config";

function Paginator({ currentPage, setPageIndex }) {
    const totalPagesToShow = 5; // Adjust this value based on your preference

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setPageIndex(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        setPageIndex(currentPage + 1);
    };

    const generatePageNumbers = () => {
        const pageNumbers = [];
        const halfTotalPagesToShow = Math.floor(totalPagesToShow / 2);
        let startPage = currentPage - halfTotalPagesToShow;

        if (startPage < 1) {
            startPage = 1;
        }

        for (let i = 0; i < totalPagesToShow; i++) {
            pageNumbers.push(startPage + i);
        }
        return pageNumbers;
    };

    return (
        <div className="pb-3">
            <span className="flex align-items-center justify-content-end">
                <span className={`bg-white cursor-pointer border-1 border-gray-300 flex align-items-center justify-content-center h-3rem pl-3 pr-3 flex-order-0 ${currentPage === 1 && "p-disabled text-gray-400"} ${config.glossary.dir === "rtl" ? "border-round-right" : "border-round-left"}`} onClick={handlePreviousClick}>
                    {config.glossary.previous}
                </span>
                {generatePageNumbers().map((pageNumber, index) => (
                    <span key={pageNumber} className={` cursor-pointer border-1 border-gray-300 flex align-items-center justify-content-center h-3rem w-3rem ${currentPage === pageNumber ? "font-bold bg-blue-100 text-blue-500" : "bg-white"} flex-order-${index + 1}`} onClick={() => setPageIndex(pageNumber)}>{pageNumber}</span>
                ))}
                <span className={`bg-white cursor-pointer border-1 border-gray-300 flex align-items-center justify-content-center h-3rem pl-3 pr-3 flex-order-${totalPagesToShow + 1} ${config.glossary.dir === "rtl" ? "border-round-left" : "border-round-right"}`} onClick={handleNextClick}>
                    {config.glossary.next}
                </span>
            </span>
        </div>
    );
}


export default Paginator;